import { render, staticRenderFns } from "./facilityStatusTableBaseInfo.vue?vue&type=template&id=6890476a"
import script from "./facilityStatusTableBaseInfo.vue?vue&type=script&lang=js"
export * from "./facilityStatusTableBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6890476a')) {
      api.createRecord('6890476a', component.options)
    } else {
      api.reload('6890476a', component.options)
    }
    module.hot.accept("./facilityStatusTableBaseInfo.vue?vue&type=template&id=6890476a", function () {
      api.rerender('6890476a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/hcf/statusTable/facilityStatusTableBaseInfo.vue"
export default component.exports